import React from "react";
import { motion } from "framer-motion";
import { ExternalLink, GitBranch, ArrowRight } from "lucide-react";
export const ProjectCard = ({ project, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.1 }}
      className="glass card p-6 rounded-xl border border-purple-500/20 hover:border-purple-400/50 transition-all duration-300 group"
    >
      {/* Project Header */}
      <div className="flex items-start justify-between mb-4">
        <h3 className="text-xl font-bold text-white group-hover:text-purple-300 transition-colors">
          {project.name}
        </h3>
        <div className="flex gap-2">
          {project.links.live && (
            <motion.a
              href={project.links.live}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-lg bg-purple-500/20 hover:bg-purple-500/30 transition-colors"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <ExternalLink className="w-4 h-4 text-purple-300" />
            </motion.a>
          )}
          {project.links.client && (
            <motion.a
              href={project.links.client}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-lg bg-purple-500/20 hover:bg-purple-500/30 transition-colors"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <GitBranch className="w-4 h-4 text-purple-300" />
            </motion.a>
          )}
        </div>
      </div>

      {/* Problem Section */}
      <div className="mb-4">
        <h4 className="text-sm font-semibold text-purple-300 mb-2 flex items-center gap-2">
          <span className="w-2 h-2 bg-red-400 rounded-full"></span>
          Description
        </h4>
        <p className="text-gray-300 text-sm leading-relaxed">
          {project.description}
        </p>
      </div>

      {/* Solution Section */}
      <div className="mb-4">
        <h4 className="text-sm font-semibold text-green-300 mb-2 flex items-center gap-2">
          <span className="w-2 h-2 bg-green-400 rounded-full"></span>
          Solution
        </h4>
        <ul className="text-gray-300 text-sm space-y-1">
          {project.features.slice(0, 3).map((feature, i) => (
            <li key={i} className="flex items-start gap-2">
              <ArrowRight className="w-3 h-3 text-purple-400 mt-0.5 flex-shrink-0" />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Tech Stack */}
      <div className="mb-4">
        <h4 className="text-sm font-semibold text-blue-300 mb-2">Tech Stack</h4>
        <div className="flex flex-wrap gap-2">
          {project.technologies.map((tech, i) => (
            <span
              key={i}
              className="px-2 py-1 bg-blue-500/20 text-blue-300 text-xs rounded-md border border-blue-500/30"
            >
              {tech}
            </span>
          ))}
        </div>
      </div>

      {/* Future Improvements */}
      {project.improvements && (
        <div className="border-t border-purple-500/20 pt-4">
          <h4 className="text-sm font-semibold text-yellow-300 mb-2">
            Future Plans
          </h4>
          <ul className="text-gray-400 text-xs space-y-1 list-disc pl-4">
            {project.improvements.slice(0, 2).map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      )}
    </motion.div>
  );
};
